var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"838848db8adc85aa8b4a230085356f8bb3eb9cce"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from "@sentry/nextjs"

if (process.env.NEXT_PUBLIC_SENTRY_ENABLED === "true") {
    const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN

    Sentry.init({
        dsn:
            SENTRY_DSN ||
            "https://8b1b0e6d63a546dcb46185217caf1470@o4504685361627136.ingest.sentry.io/4504685363068928",
        // Adjust this value in production, or use tracesSampler for greater control
		tracesSampleRate: process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE, // For Performance Metrics we want around 0.0133 due to high amount of traffic
		sampleRate: process.env.NEXT_PUBLIC_SENTRY_SAMPLE_RATE, // For Error Events we want a different number. a 0.4 is fine.

        release: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
        environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
    })
}
